import { configureStore } from "@reduxjs/toolkit";

import countrySlice from "../pages/country/redux/countrySlice";
import chatSlice from "../pages/chat/redux/chatSlice";
import transactionSlice from "../pages/transaction/redux/transactionSlice";
import managementSlice from "../pages/management/redux/managementSlice";
import betOptionSlice from "../pages/betOption/redux/betOptionSlice";
import authSlice from "../pages/auth/redux/authSlice";
import roomSlice from "../pages/room/redux/roomSlice";
import botSlice from "../pages/bot/redux/botSlice";
import adminSlice from "../pages/admin/redux/adminSlice";
import branchSlice from "../pages/branch/redux/branchSlice";

const store = configureStore({
  reducer: {
    auth: authSlice,
    betOption: betOptionSlice,
    management: managementSlice,
    transaction: transactionSlice,
    chat: chatSlice,
    country: countrySlice,
    room: roomSlice,
    bot: botSlice,
    admin: adminSlice,
    branch: branchSlice,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    });
  },
});

export default store;
